import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { startOfDay, format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import api from '../../../api/axios';

export default function WorkDateSelector({ employee_id, wfhWorkDates, employeeWFHDates }) {
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState([]); // New non-WFH dates
  const [deselectDates, setDeselectDates] = useState([]); // Selected WFH dates with IDs
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  const timeZone = 'Asia/Kolkata';
  console.log("deselectDates", deselectDates)

  const open = () => setShow(true);
  const close = () => setShow(false);

  const normalizeDate = (date) => {
    try {
      // Ensure input is a valid Date object
      if (!(date instanceof Date) || isNaN(date.getTime())) {
        throw new Error('Invalid date input');
      }
      const zonedDate = toZonedTime(date, timeZone);
      return startOfDay(zonedDate);
    } catch (error) {
      console.error('Error normalizing date:', error);
      return null; // Return null for invalid dates
    }
  };

  // Convert wfhWorkDates to normalized Date objects with their IDs
  const wfhDates = wfhWorkDates ?  wfhWorkDates
    .filter((wfh) => !isNaN(new Date(wfh.work_date).getTime())) // Filter out invalid dates
    .map((wfh) => ({
      date: normalizeDate(new Date(wfh.work_date)),
      id: wfh?.wfh_id,
    }))
    .filter((wfh) => wfh.date !== null) : null; // Remove null dates
  console.log("wfhDates", wfhDates);

  const toggleDate = (day) => {
    const normalizedDay = normalizeDate(day);
    if (!normalizedDay) {
      console.error('Invalid date selected:', day);
      return; // Skip invalid dates
    }
    const dateStr = format(normalizedDay, 'yyyy-MM-dd');
    const wfhEntry = wfhDates ?  wfhDates.find((wfh) => format(wfh.date, 'yyyy-MM-dd') === dateStr) : null;

    if (wfhEntry) {
      // Handle WFH date: toggle in deselectDates
      const existsInDeselect = deselectDates.find(
        (d) => format(d.date, 'yyyy-MM-dd') === dateStr
      );
      if (existsInDeselect) {
        setDeselectDates((prev) =>
          prev.filter((d) => format(d.date, 'yyyy-MM-dd') !== dateStr)
        );
      } else {
        setDeselectDates((prev) => [...prev, { date: normalizedDay, id: wfhEntry.id }]);
      }
    } else {
      // Handle non-WFH date: toggle in selected
      const existsInSelected = selected.find(
        (d) => format(d, 'yyyy-MM-dd') === dateStr
      );
      if (existsInSelected) {
        setSelected((prev) =>
          prev.filter((d) => format(d, 'yyyy-MM-dd') !== dateStr)
        );
      } else {
        setSelected((prev) => [...prev, normalizedDay]);
      }
    }
  };

  const handleSave = async () => {
    const assigned_id = localStorage.getItem('employeeID');
    if (selected.length === 0 && deselectDates.length === 0) {
      setMsg({ type: 'warning', text: 'Please select at least one date.' });
      return;
    }
    setLoading(true);
    setMsg(null);
    try {
      // Combine selected (new dates) and deselectDates (WFH dates with IDs)
      const payload = [
        ...selected
          .filter((date) => !isNaN(date.getTime())) // Filter out invalid dates
          .map((date) => ({ date: format(date, 'yyyy-MM-dd'), id: null })),
        ...deselectDates
          .filter((d) => !isNaN(d.date.getTime())) // Filter out invalid dates
          .map((d) => ({ date: format(d.date, 'yyyy-MM-dd'), id: d.id })),
      ].sort((a, b) => a.date.localeCompare(b.date));
      await api.post(`company/work_date?employee_id=${employee_id}&assigned_id=${assigned_id}`, {
        dates: payload,
      });
      if (deselectDates?.length > 0) {
        await api.put(`company/deselect_wfh_date?employee_id=${employee_id}&assigned_id=${assigned_id}`, {
          dates: deselectDates,
        });
      }
      employeeWFHDates();
      setMsg({ type: 'success', text: 'Dates saved successfully.' });
      setSelected([]);
      setDeselectDates([]);
      close();
    } catch (err) {
      console.error(err);
      setMsg({ type: 'danger', text: err?.response?.data?.message || 'Save failed' });
    } finally {
      setLoading(false);
    }
  };

  // Define modifiers for DayPicker
  const modifiers = {
    pending_wfh: wfhDates?.filter(
        (wfh) =>
          !deselectDates.some(
            (d) => format(d.date, 'yyyy-MM-dd') === format(wfh.date, 'yyyy-MM-dd')
          ) && wfh?.approved_status == 'pending'
      )
      .map((wfh) => wfh.date), 
      // Only pending WFH dates
    wfh: wfhDates?.filter(
        (wfh) =>
          !deselectDates?.some(
            (d) => format(d.date, 'yyyy-MM-dd') === format(wfh.date, 'yyyy-MM-dd')
          ) && wfh.approved_status != 'pending'
      )
      .map((wfh) => wfh?.date), // Approved/Rejected but not pending

    deselect: deselectDates?.map((d) => d.date), // Selected WFH dates

    nonWFHSelected: selected,

    
  };

  console.log("modifiers", modifiers)


  const modifiersStyles = {
    wfh: {
      backgroundColor: ' #2e5077ff', // Bootstrap bg-info
      color: '#fff',
      fontSize: 14
    },

    pending_wfh: {
      backgroundColor: ' #f8e51dff', // Bootstrap bg-info
      color: '#fff',
      fontSize: 14
    },
    deselect: {
      backgroundColor: '#dc3545', // Bootstrap bg-danger
      color: '#fff',

      fontSize: 14
      // fontWeight: 'bold',
    },
    nonWFHSelected: {
      backgroundColor: ' #17a2b8', // Bootstrap bg-primary
      color: '#fff',
      fontSize: 14
      // fontWeight: 'bold',
    },
  };

  const dayPickerStyles = {
    root: 'rdp rounded border  bg-white p-4 shadow-lg',
    day: 'rounded-circle p-2 mx-1 transition-colors duration-200',
    day_today: 'text-danger font-weight-bold border border-danger rounded-circle',
    day_disabled: 'text-muted opacity-50',
    caption: 'mb-3 text-lg font-semibold text-dark',
    nav_button: 'btn btn-sm btn-outline-primary rounded-circle p-2',
    nav_button_previous: 'ms-2',
    nav_button_next: 'me-2',
    head: 'text-dark',
    table: 'w-full',
    cell: 'p-1',
  };

  const inlineStyles = {
    modal: {
      fontFamily: "'Arial', sans-serif",
    },
    instructions: {
      color: '#495057',
      marginBottom: '1.5rem',
      fontSize: '0.95rem',
    },
    selectedDates: {
      marginTop: '1.5rem',
    },
    badgeContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0.5rem',
    },
    badge: {
      padding: '0.5rem 1rem',
      borderRadius: '1rem',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      fontSize: '0.9rem',
      transition: 'background-color 0.2s',
    },
    badgeIcon: {
      cursor: 'pointer',
      fontSize: '0.8rem',
    },
    alert: {
      marginTop: '1.5rem',
      borderRadius: '0.5rem',
      padding: '0.75rem',
    },
  };

  return (
    <>
      <button
        className="btn btn-success mx-2"
        onClick={open}
      >
        Allow WFH
      </button>

      <Modal show={show} onHide={close} size="lg" style={inlineStyles.modal}>
        <Modal.Header
          closeButton
          style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e9ecef', padding: '1.25rem' }}
        >
          <Modal.Title>Select Work Dates</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '1.5rem' }}>


          <DayPicker
            mode="multiple"
            onDayClick={toggleDate}
            classNames={dayPickerStyles}
            style={{ margin: '0 auto', maxWidth: '400px' }}
            modifiers={modifiers}
            modifiersStyles={modifiersStyles}
          />

          <hr style={{ margin: '1.5rem 0', borderColor: '#e9ecef' }} />

          {(selected.length > 0 || deselectDates.length > 0) && (
            <div style={inlineStyles.selectedDates}>
              <div style={{ fontWeight: '600', marginBottom: '0.75rem', color: '#343a40' }}>
                Selected Dates:
              </div>
              <div>
                {[...selected, ...deselectDates.map((d) => d.date)]
                  .filter((date) => !isNaN(date.getTime())) // Filter out invalid dates
                  .sort((a, b) => a - b)
                  .map((date, index) => {
                    const isDeselect = deselectDates.some(
                      (d) => format(d.date, 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd')
                    );
                    return (
                      <span key={index} className="badge-wrapper">
                        <span className={`badge ${isDeselect ? 'bg-danger' : 'bg-primary'} text-white mx-2`}>
                          <span>{format(date, 'yyyy-MM-dd')}</span>
                          {/* <i
                            className="fa-solid fa-xmark px-1"
                            onClick={() => toggleDate(date)}
                          ></i> */}
                        </span>
                      </span>
                    );
                  })}
              </div>
            </div>
          )}


        </Modal.Body>
        <Modal.Footer style={{ borderTop: '1px solid #e9ecef', padding: '1.25rem' }}>
          <Button
            variant="secondary"
            onClick={close}
            style={{ borderRadius: '0.5rem', padding: '0.5rem 1.5rem' }}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={loading}
            style={{ borderRadius: '0.5rem', padding: '0.5rem 1.5rem', fontWeight: '500' }}
          >
            {loading ? 'Saving...' : 'Save Dates'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}